import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "color", "bg", "theme", "title", "svgStyle"];
import React from 'react';
import { withTheme } from 'styled-components';
import Box from '../Box';
var CircleChevronIcon = withTheme(function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '14px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '14px' : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'ctrlBg' : _ref$color,
      _ref$bg = _ref.bg,
      bg = _ref$bg === void 0 ? 'labelPlaceholder' : _ref$bg,
      theme = _ref.theme,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'AMP/Additive Filter/Element/Circle Chevron/Closed' : _ref$title,
      svgStyle = _ref.svgStyle,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    mt: "1px",
    ml: "5px"
  }, props), /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 14 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: svgStyle
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    id: "circle-chevron-closed",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: theme.colors[bg] || bg,
    fillRule: "nonzero",
    x: "3",
    y: "3",
    width: "8",
    height: "8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00338383,14 C10.8505073,14 14,10.8461165 14,6.99662118 C14,3.15388349 10.8505073,0 7.00338383,0 C3.14949171,0 0,3.15388349 0,6.99662118 C0,10.8461165 3.14949171,14 7.00338383,14 Z M5.65381411,10.3728647 C5.44657003,10.1648746 5.45304583,9.83339004 5.64733831,9.65139865 L8.44514726,6.99952089 L5.64733831,4.36714775 C5.44009422,4.17865589 5.45952164,3.84067128 5.66028992,3.63918126 C5.8545824,3.44419031 6.16545312,3.45718848 6.37917301,3.65867851 L9.21584137,6.33005536 C9.59795053,6.69403631 9.59147472,7.31800825 9.21584137,7.68198919 L6.37917301,10.3533656 C6.18488053,10.5353574 5.83515499,10.5548565 5.65381411,10.3728647 Z",
    id: "Fill-1",
    fill: theme.colors[color] || color,
    fillRule: "nonzero"
  }))));
});
export default CircleChevronIcon;